import { chatLabels } from './labels/chatLabels.ts';
import { roleplayLabels } from './labels/roleplayLabels.ts';
import { meetingLabels } from './labels/meetingLabels.ts';
import { webappLabels } from './labels/webappLabels.ts';
import { journeyLabels } from './labels/journeyLabels.ts';
import { nuggetLabels } from './labels/nuggetLabels.ts';

const domains = [
  chatLabels,
  roleplayLabels,
  meetingLabels,
  webappLabels,
  journeyLabels,
  nuggetLabels,
];

/* One table for every channel; each domain keeps its copy in its own file. */
const labels = {
  ...chatLabels,
  ...roleplayLabels,
  ...meetingLabels,
  ...webappLabels,
  ...journeyLabels,
  ...nuggetLabels,
};

/* A key in two domain files would silently keep only the last copy. */
const domainKeyCount = domains.reduce(
  (sum, domain) => sum + Object.keys(domain).length,
  0,
);
if (domainKeyCount !== Object.keys(labels).length) {
  throw new Error('duplicate label key');
}

export type TranslateKey = keyof typeof labels;

/**
 * Get a translated UI string by key (static map lookup).
 * Falls back to English when the language is not available.
 */
export function translate(key: TranslateKey, language: string): string {
  const entry = labels[key];
  return (entry as Record<string, string>)[language] ?? entry.en;
}
